<template>
  <div v-loading.fullscreen.lock="state.loading" element-loading-background="rgba(255, 255, 255, 0.5)">
    <vue-particles id="wft-tsparticles" :options="options" :particlesInit="particlesInit" />
    <div class="formWrapper">
      <h3>锂研数科后台管理系统</h3>
      <el-form ref="loginFormRef" :model="state.formValue" status-icon :rules="state.formRules" label-width="60px"
        class="loginForm">
        <el-form-item label="账号" prop="phone">
          <el-input v-model="state.formValue.phone" autocomplete="off" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="state.formValue.password" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onBeforeUnmount, onMounted } from "vue";
import { loadSlim } from "tsparticles-slim"
import { useRouter } from 'vue-router'
import { loginFun } from "@/api/index";
import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
const loginFormRef = ref();
const state = reactive({
  formValue: {
    phone: "",
    password: ""
  },
  formRules: {
    phone: [{ required: true, message: "请输入账号", trigger: "blur" }],
    password: [{ required: true, message: "请输入密码", trigger: "blur" }],
  },
  loading: false,
})
// 登录
const submitForm = () => {
  // 1.校验表单
  loginFormRef.value.validate((valid) => {
    if (valid) {
      state.loading = true;
      loginFun(state.formValue).then((res) => {
        store.commit("changeUserInfo", res.data);
        store.commit("changeGetterRouter", false);
        router.push("/userManage/userList");
      }).finally(() => {
        state.loading = false;
      });
    }
  })
}
// 背景配置参数
let options = {
  background: {
    color: {
      value: '#2d3a4b'
    }
  },
  fpsLimit: 120,
  interactivity: {
    modes: {
      bubble: {
        distance: 400,
        duration: 2,
        opacity: 0.8,
        size: 40
      },
      push: {
        quantity: 4
      },
      repulse: {
        distance: 200,
        duration: 0.4
      }
    }
  },
  particles: {
    color: {
      value: '#ffffff'
    },
    links: {
      color: '#ffffff',
      distance: 150,
      enable: true,
      opacity: 0.5,
      width: 1
    },
    collisions: {
      enable: true
    },
    move: {
      direction: 'none',
      enable: true,
      outMode: 'bounce',
      random: false,
      speed: 6,
      straight: false
    },
    number: {
      density: {
        enable: true,
        area: 800
      },
      value: 80
    },
    opacity: {
      value: 0.5
    },
    shape: {
      type: 'circle'
    },
    size: {
      random: true,
      value: 5
    }
  },
  detectRetina: true
}
let engineConfig = null;
const particlesInit = async (engine) => {
  engineConfig = engine;
  await loadSlim(engine);
}
onMounted(() => {
})
onBeforeUnmount(() => {
  // 销毁Particles实例，防止浏览器崩溃
  if (engineConfig) {
    engineConfig._domArray[0].destroyed = true;
    loadSlim(engineConfig);
  }
})
</script>
<style lang="scss" scoped>
.formWrapper {
  width: 450px;
  height: 240px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba($color: #000000, $alpha: 0.5);
  color: white;
  text-align: center;
  padding: 20px;
  border-radius: 8px;

  h3 {
    font-size: 30px;
    padding: 10px 0 20px;
  }

  .loginForm {
    margin-top: 20px;
  }
}

:deep .el-form-item__label {
  color: white;
}
</style>